const getCom = page => () => import(`@/view/${page}`)
export default [
  {
    path: '/',
    name: 'index',
    meta: {
      title: '首页'
      // hideInMenu: true
    },
    component: getCom('index')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
      // hideInMenu: true
    },
    component: getCom('login')
  },
  {
    path: '/position',
    name: 'position',
    meta: {
      title: '广告位'
      // hideInMenu: true
    },
    component:getCom('index/position')
  },
  {
    path: '/case',
    name: 'case',
    meta: {
      title: '案例展示'
      // hideInMenu: true
    },
    component:getCom('index/case')
  },
  {
    path: '/caseDetail',
    name: 'caseDetail',
    meta: {
      title: '案例展示详情'
      // hideInMenu: true
    },
    component:getCom('index/caseDetail')
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      title: '关于我们'
      // hideInMenu: true
    },
    component:getCom('index/about')
  },
  {
    path: '/agree',
    name: 'agree',
    meta: {
      title: '协议'
      // hideInMenu: true
    },
    component:getCom('index/agree')
  },
  { 
    path:'/home',
    name:'home',
    meta: {
      title: '趣编首页'
      // hideInMenu: true
    },
    component: getCom('common'),
    children:[
      {
        path: 'index',
        name: 'home',
        meta: {
          title: '趣编首页'
          // hideInMenu: true
        },
        component: getCom('home')
      },
      {
        path: 'ad',
        name: 'ad',
        meta: {
          title: '广告'
        },
        component: getCom('ad')
      },
      {
        path: 'extenAD',
        name: 'extenAD',
        meta: {
          title: '推广广告'
        },
        component: getCom('extenAD')
      },
      {
        path: 'finance',
        name: 'finance',
        meta: {
          title: '财务'
        },
        component: getCom('finance')
      },
      {
        path: 'account',
        name: 'account',
        meta: {
          title: '账号管理'
        },
        component: getCom('account')
      },
      {
        path: 'message',
        name: 'message',
        meta: {
          title: '消息中心'
        },
        component: getCom('message')
      },
      {
        path: 'adType',
        name: 'adType',
        meta: {
          title: 'adType'
        },
        component: getCom('adType')
      },
      {
        path: 'adLast',
        name: 'adLast',
        meta: {
          title: 'adLast'
        },
        component: getCom('adLast')
      },
      {
        path: 'newAd',
        name: 'newAd',
        meta: {
          title: 'newAd'
        },
        component: getCom('newAd')
      },
      {
        path: 'reconciliation',
        name: 'reconciliation',
        meta: {
          title: 'reconciliation'
        },
        component: getCom('reconciliation')
      }
    ]
  },
  
]



// WEBPACK FOOTER //
// ./src/router/routers.js